<script setup lang="ts">
const faqs = [
  {
    question: 'Apa itu cek ongkir KiriminAja?',
    answer:
      'Cek ongkir KiriminAja adalah fitur yang bisa kamu gunakan untuk mengecek berapa biaya pengiriman paket yang harus dibayar dalam menggunakan jasa ekspedisi dari satu lokasi ke lokasi lainnya. Di sini kamu bisa cek ongkir semua ekspedisi dan juga cek ongkir cargo.'
  },
  {
    question: 'Apa itu ongkos kirim?',
    answer:
      'Ongkos kirim adalah biaya kirim barang yang ditentukan berdasarkan jarak pengiriman, berat dan dimensi barangnya. Ongkir ini ditanggung oleh pembeli atau penerima dalam sebuah transaksi.'
  },
  {
    question: 'Apa tujuan dari aggregator logistik?',
    answer:
      'Manfaat dari penggunaan cek ongkir KiriminAja adalah kamu bisa memberikan transparansi kepada pelangganmu mengenai biaya kirim barang yang diperlukan. <br/> Selain itu kamu juga bisa mengelola biaya pengiriman jadi lebih efisien karena bisa memilih mana harga yang paling ekonomis. Dengan cek tarif yang sesuai kamu bisa membuat pelanggan jadi lebih senang dan percaya dengan bisnismu.'
  },
  {
    question: 'Bagaimana cara cek ongkir via KiriminAja?',
    answer: 'Gimana cara cek ongkir via KiriminAja? Caranya mudah kok:'
  },
  {
    question:
      'Apa saja jenis layanan pengiriman yang tersedia pada fitur cek ongkir KiriminAja?',
    answer:
      'Setelah kamu cek ongkir, akan muncul berbagai jenis layanan pengiriman yang ada seperti Reguler, One Day, Next Day, Ekonomi dan Kargo. Di bawahnya juga banyak pilihan jasa ekspedisi beserta tarif ongkirnya, estimasi, apakah bisa COD, pick up dan drop off.'
  }
]
</script>
<template>
  <LazyVisibleFaqBase :faqs="faqs" hydrate-on-visible />
</template>
